import React from 'react'
import pdfLogo from 'images/pdf-logo.png'
import bg from 'images/personas/bg-content-day.jpg'
import LimitedViewText from './LimitedViewText'
import {getTopThree, getBottomThree, getDayOfWeek} from './helper'

const WhenWhat = ({
                      topDays, limitedView, bottomDays, topHours, bottomHours,
                      topInterests, photo
                    }) => {
  const content = (
    <React.Fragment>
      <div
        className="bg-center bg-cover bg-no-repeat col-6 relative sm-col-12"
        style={{ backgroundImage: `url('${bg}')` }}
      >
        <div className="flex pt4 px4 relative sm-p3 z1">
          <div className="bg-violet-red mr2 rounded-6" style={{ height: 20, width: 20 }} />
          <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
          <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
          <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
        </div>

        <div className="image-layer image-layer--black absolute bottom-0 left-0 right-0 top-0" />

        <p className="persona-sub-title px4 py3 relative sm-p3 text-white z1">Over the last month, 1 day of the week stands out</p>
      </div>

      <div className="col-6 flex flex-center p4 sm-col-12 sm-px0 sm-py3 x-lg-p3">
        <ul className="fs-18 x-lg-h4">
          <li className="mb2">
            {
              !limitedView
              && (
                <span>
                    {getDayOfWeek(topDays.map(interest => interest.name)[0])}&nbsp;
                  </span>
              )
              || <LimitedViewText />
            }

            stands out the most. This is the day of the week they are most actively talking about your industry.
          </li>

          <li className="mb2">
            {
              !limitedView
              && (
                <span>
                    {getDayOfWeek(bottomDays.map(interest => interest.name)[0])}&nbsp;
                  </span>
              )
              || <LimitedViewText />
            }

            is the least active day for your audience.
          </li>

          <li className="mb2">
            {
              !limitedView
              && (
                <span>
                    {topHours.map(interest => interest.name)[0]}&nbsp;
                  </span>
              )
              || <LimitedViewText />
            }

            is when they are most actively engaged in conversations related to your industry, and {bottomHours.map(interest => interest.name)[0]} is the lowest.
          </li>
        </ul>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <section className="section" data-anchor="content_when">
        <div className="slider-box slider-box--sm-p0 slider-box--pdf-p0 bg-white box-shadow-box flex flex-wrap sm-flex-column-reverse">
          <div className="flex flex-wrap sm-py3">
            {content}
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

export default WhenWhat
